import {CollectionFactory} from '@modifi/redux'
import {path} from 'ramda'
import {getAuthenticatedAdminAresClient} from '@modifi/trade-api-clients'
import {REDUCER_KEY} from '../constants'

const ACTION_TYPES = {
  SET_RELEVANT_FLAG: 'transaction/SET_RELEVANT_FLAG',
}

const initialState = {
  isRelevant: true,
}

export const featureReducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case ACTION_TYPES.SET_RELEVANT_FLAG: {
      return {
        ...state,
        isRelevant: payload,
      }
    }
    default:
      return state
  }
}

export const selectRelevantFlag = state => path([REDUCER_KEY, 'feature', 'isRelevant'], state)

export const aSetRelevantFlag = flag => ({
  type: ACTION_TYPES.SET_RELEVANT_FLAG,
  payload: flag === true,
})

const {actions, selectors, reducer} = CollectionFactory({
  actionNamePrefix: `transactions/collection`,
  rootSelector: state => state?.transactions?.data,
  fetchRequest: (state, {isRelevant}) => {
    const client = getAuthenticatedAdminAresClient()
    return client.BankTransactions.all({
      processed: false,
      relevant: isRelevant,
    }).then(response => response.data().bankTransactions)
  },
  entityPrimaryKeySelector: path(['id']),
})

export default reducer

export const {
  selectByKeyWindow: selectTransactionsByKeyWindow,
  selectIsKeyWindowLoading: selectTransactionsIsKeyWindowLoading,
  selectById: selectTransactionById,
} = selectors

export const {deleteEntity: aDeleteTransactionEntity} = actions

export const aFetchTransactions = keyWindow => actions.fetch(keyWindow)
